
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/abo/[slug]",
      function () {
        return require("private-next-pages/abo/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/abo/[slug]"])
      });
    }
  